import { Module } from 'vuex'
import getters from '@/store/settings/getters'
import actions from '@/store/settings/actions'
import mutations from '@/store/settings/mutations'
import { SettingsState } from '@/store/settings/types'
import { RootState } from '@/store/types'

import PStorage from '@/util/PStorage'

const state: SettingsState = {
    preferences: {}
}

const editor: Module<SettingsState, RootState> = {
    state,
    getters,
    actions,
    mutations
}

export default editor
